/**
 * ORDERS CONSTANTS
 */
export const OTH = 'OTH';
export const ADM = 'ADM';
export const LOC = 'LOC';
export const DIS = 'DIS';
export const CPF = 'CPF';
export const PSO = 'PSO';
export const RTN = 'RTN';
export const CC = 'CC';
export const PCPF = 'PCPF';
export const PRN = 'PRN'; // DISNO discharge non order- revoked/transferred/death discharges

export const DISNO = 'DISNO';
export const FC = 'FC';
export const MMD = 'MMD';
export const NOTES_LETTER_CODE = 'N';
export const BOTH_LETTER_CODE = 'B'; // written agreement

export const WA = 'WA'; // incomplete status approval

export const IA = 'IA'; // verbal agreement status

export const VA = 'VA'; // entitytypeshortname to create a note

export const PPN = 'PPN'; // Discharge types

export const DEATH = 'DEATH';
export const REVOKED = 'REVOKED';
export const TRANSFERRED = 'TRANSFERRED';
export const FOR_CAUSE = 'FOR_CAUSE';
export const LEFT_GEOGRAPHIC_AREA = 'LEFT_GEOGRAPHIC_AREA';
export const NON_CERTIFIED = 'NON_CERTIFIED';
export const GeneralOrder = 'General Order';
export const MedicationChange = 'Medication Change';
export const CPVisitFrequencies = 'Visit Frequencies';
export const LOCchange = 'LOC Change';
export const FACchange = 'Location Change';
export const AdmitOrder = 'Patient Admission';
export const DischargeOrder = 'Discharge Patient';
export const PSOorder = 'Patient Standing Orders';
export const PRNOrder = 'PRN Orders';
export const LEFT_GEOGRAPHIC_AREA_NAME = 'Discharged: Left Geographic Area';
export const FOR_CAUSE_NAME = 'Discharged: For cause';
export const NON_CERTIFIED_NAME = 'Discharged: Non Certification';